import styled from 'styled-components'

function Textarea({value, setValue, placeholder}) {
    const onChange = event => {
        setValue(event.target.value)
    }

    return (
        <Wrapper>
            <textarea placeholder={placeholder} onChange={onChange} defaultValue={value}></textarea>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    textarea {
        background-color: #f4f4f452;
        border: 1px solid rgba(0,0,0,0.2);
        border-radius: 10px;
        padding: 10px;
        text-align: left;
        font-size: 15px;
        font-family: 'Inter', sans-serif;
        width: 100%;
        height: 60px;
    }
    position: relative;
    color: ${props => props.selected ? '#000000' : '#000000'};
`;


export default Textarea;
